import React, { useState, useEffect } from 'react';
import whatsapp_icon from "../../../../../assets/icons/whatsapp_green.svg";
import { Button, Badge, Tooltip } from "antd";
import DatePicker from './DatePicker/DatePicker';
import { Travelers } from './Travelers';
import { Experience } from '../../../../../context/dataExperienceContext';
import { useCurrency } from '../../../../../context/currencyContext';
import CancellationPolicy from '../CancellationPolicy';

interface AvailabilityProps {
    price: {
        currency: string,
        fromPrice: number,
        fromPriceBeforeDiscount?: number | undefined,
        promoterComission: number,
    },
    product: {
        pricingInfo: Experience['product']['pricingInfo'],
        bookingRequirements: Experience['product']['bookingRequirements'],
        cancellationPolicy: Experience['product']['cancellationPolicy'],
    },
    availabilitySchedule: Experience['availabilitySchedule'],
    handleSubmit: () => void;
    handlePhoneClick: () => void;
    onDateChange: (date: string) => void;
    selectedDate?: string;
}


const Availability = ({
    price,
    product,
    handleSubmit,
    handlePhoneClick,
    availabilitySchedule,
    onDateChange,
    selectedDate,
}: AvailabilityProps) => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        setIsSmallScreen(window.innerWidth <= 768);

        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isSmallScreen]);

    const Price = () => {
        const { convert } = useCurrency();
        const { value, code } = convert(price.fromPrice, price.currency);
        const includingComissions = value + price.promoterComission;
        return `Desde ${code} ${includingComissions.toFixed(2)}`;
    }

    const PriceUnit = () => {
        if (product.pricingInfo.type === 'UNIT') {
            const { maxTravelersPerBooking } = product.bookingRequirements;
            return `por grupo (hasta ${maxTravelersPerBooking} personas)`;
        }
        return 'por persona';
    }

    const Saving = () => {
        const { convert } = useCurrency();
        if (price.fromPriceBeforeDiscount) {
            const { value: convertedFromPriceBeforeDiscount, code } = convert(price.fromPriceBeforeDiscount, price.currency);
            const { value: convertedFromPrice } = convert(price.fromPrice, price.currency);

            const savings = convertedFromPriceBeforeDiscount - convertedFromPrice;

            return <span>
                {code} {convertedFromPriceBeforeDiscount}
                <span style={{ color: 'red' }}>Ahorre {code} {savings.toFixed(2).replace('.', ',')}</span>
            </span>;
        }
        return undefined;
    }

    const RibbonWrapper = ({ children }: { children: React.ReactNode }) => {
        if (price.fromPriceBeforeDiscount) {
            return (
                <Badge.Ribbon
                    text={
                        <Tooltip title="Oferta especial por tiempo limitado">
                            Oferta Especial
                        </Tooltip>
                    }
                    color="red"
                    placement="start"
                >
                    {children}
                </Badge.Ribbon>
            )
        } else return children;
    }

    return (
        <RibbonWrapper>
            <div className="pricebox__container">
                <div className="quotation-details__container">
                    {!isSmallScreen && (
                        <div>
                            <div className="quotation-price">
                                <div className="h2">
                                    <h2>
                                        <Price />
                                    </h2>
                                    <span><PriceUnit /></span>
                                </div>
                            </div>
                            <Saving />
                        </div>
                    )}
                    <div className="num-people__container">
                        <h3>Seleccionar fecha y viajeros</h3>
                    </div>
                    <DatePicker
                        promoterComission={price.promoterComission}
                        availabilitySchedule={availabilitySchedule}
                        onDateSelect={(date) => {
                            onDateChange(date);
                        }}
                        selectedDate={selectedDate}
                    />
                    <Travelers product={product}/>
                    <div style={{ fontSize: '14px', paddingTop: '12px' }}>
                        <CancellationPolicy 
                            cancellationPolicy={product.cancellationPolicy}
                        />
                    </div>
                    <div className="checkout-actions">
                        <button
                            onClick={handleSubmit}
                        >
                            Comprobar Disponibilidad
                        </button>
                    </div>
                </div>
                <Button
                    className="phone"
                    onClick={handlePhoneClick}
                    type="link"
                >
                    <span>¿Tienes dudas?</span>
                    <img className="wp_img" src={whatsapp_icon} alt="icono de whatsapp" />
                </Button>
            </div>
        </RibbonWrapper>
    );
};

export default Availability;